import beep from '../audio/call-waiting-indicator.mp3';
import ring from '../audio/ringing.mp3';

export const ringAudio = new Audio(ring);
ringAudio.loop = true;
export const beepAudio = new Audio(beep);
